// src/api/brand.js
import { post, get, globalPut, remove, postpro } from '../index';

/** ========== Brand Connect Session (NEW) ========== **/
/**
 * 1) Start draft brand + brandSettings (both with deleted:true)
 * Response: { brandId, brandSettingsId }
 */
export const startBrandConnectSession = () =>
  post('/brands/connect-session/start', {}, false);

/**
 * 2) Commit draft: flip both to active (deleted:false) and patch details
 * body = { brandId, name, description, img, settingsPatch }
 * Response: { ...brand, brandSettings: {...} }
 */
export const commitBrandConnectSession = (body) =>
  globalPut('/brands/connect-session/commit', body, false);

/**
 * 3) Abandon draft: keep soft-deleted (server will keep deleted:true),
 * or you can hard-delete there if you change the route behavior.
 */
export const abandonBrandConnectSession = (brandId) =>
  remove(`/brands/connect-session/abandon/${brandId}`);

/**
 * Wizard-field proposals derived from brandSettings.brandProfile (the
 * enrichment worker's output). The wizard uses these to prefill empty
 * inputs. The server never overwrites stored values — applying is a
 * frontend concern.
 * Response: { proposal: {...}, source: {...}, enrichedAt, confidence }
 */
export const getProposedBrandFields = (brandId) =>
  get(`/brands/${brandId}/proposed-fields`);

/**
 * Persist a single Apply'd AI suggestion to backend. Server updates the
 * field on Brand or BrandSettings AND records the acceptance so the
 * next /proposed-fields fetch suppresses the same suggestion.
 * Response: { ok, brand: { ...withBrandSettings } }
 */
export const acceptProposedField = (brandId, field, value) =>
  post(`/brands/${brandId}/accept-proposal`, { field, value }, false);

/**
 * Toggle whether the AI enrichment proposes a value for this field.
 * enabled=false → stop proposing for this field. enabled=true → re-enable.
 * Response: { ok, disabledProposals: { [field]: true, ... } }
 */
export const toggleProposedField = (brandId, field, enabled) =>
  post(`/brands/${brandId}/toggle-proposal`, { field, enabled }, false);

/**
 * Record a Dismiss on the backend so the same proposed value doesn't
 * re-pop on every poll. Server stores the dismissed value into the
 * same acceptedProposals map the /proposed-fields endpoint reads;
 * a future enrichment proposing a DIFFERENT value will re-surface.
 */
export const dismissProposedField = (brandId, field, proposedValue) =>
  post(`/brands/${brandId}/dismiss-proposal`, { field, proposedValue }, false);